import styles from './index.module.scss';

export default function BigText({
    children,
   }) {
    return (
        <div className={styles.title}>{children}</div>
    );
}